import { of, switchMap } from "rxjs";
import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";

import { resolveInternalHomeUrl } from "@azm/core/guards/internal-home";
import { AuthService } from "@azm/core/services/auth";
import { SidebarService } from "@azm/core/services/sidebar";
import { PERMISSIONS, splitPermissionCode } from "@azm/shared/enums/permissions";

export const permissionsGuard: CanActivateChildFn = (childRoute, _state) => {
	const router = inject(Router);
	const authService = inject(AuthService);
	const sidebarService = inject(SidebarService);

	const featurePermission = childRoute.data["permission"] as string | undefined;
	if (!featurePermission) return true;

	const actionPermission = childRoute.data["actionPermission"] ?? PERMISSIONS.CAN_VIEW;
	const actions = Array.isArray(actionPermission) ? actionPermission : [actionPermission];

	const requiredCodes = actions.map((action: string) => (splitPermissionCode(action) ? action : `${featurePermission}.${action}`));

	return authService.getUserPermissions().pipe(
		switchMap(() => {
			const hasPermissions = authService.hasAnyPermission(requiredCodes);
			if (hasPermissions) return of(true);
			if (featurePermission === "DASHBOARD") {
				return resolveInternalHomeUrl(authService, sidebarService, router);
			}
			void router.navigateByUrl("/error/403");
			return of(false);
		}),
	);
};
